import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedRow: null,
  formData: {
    part_id: '',
    part_name: '',
    part_isconsumable: 0,
    part_number: '',
    part_interchange: '',
    category_id: '',
    vendor_id: '',
    vendor_name: '',
    part_location: '',
    part_remarks: '',
    satuan_id: '',
    part_brand: '',
    part_status: '',
    part_createdby: '',
    part_createddate: '',
    part_modifyby: '',
    part_modifydate: '',
    rowid: '',
    photo_ori: '',
    photo_kw: '',
  },
  dataList: [],
  totalData: 0,
  loading: false,
  error: null,
  loadingMessage: '',
  activeTab: 0,
};

const mst07partSlice = createSlice({
  name: 'mst07part',
  initialState,
  reducers: {
    setSelectedRow: (state, action) => { state.selectedRow = action.payload; },
    setFormData: (state, action) => { state.formData = action.payload; },
    clearFormData: (state) => { state.formData = initialState.formData; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    fetchDetailSuccess: (state, action) => { state.formData = { ...initialState.formData, ...action.payload }; state.loading = false; state.error = null; },
    fetchDetailFailure: (state, action) => { state.loading = false; state.error = action.payload; },
    fetchDetailError: (state, action) => { state.loading = false; state.error = action.payload; },
    updateFormData: (state, action) => { state.loading = false; state.formData = { ...state.formData, ...action.payload }; },
    resetState: () => initialState,
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    clearModuleState: (state) => {
      state.activeTab = 0;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.selectedRow = null;
      state.formData = initialState.formData;
    },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
  },
});

export const { setSelectedRow, setFormData, clearFormData, setLoading, setErrorMsg, setLoadingMessage, fetchDetailSuccess, fetchDetailFailure, fetchDetailError, resetState, updateFormData, setActiveTab, setDataList, setTotalData, clearModuleState } = mst07partSlice.actions;

export default mst07partSlice.reducer;
